import { AuthTokenProvider } from "@charphq/api-client";

/**
 * Better Auth token provider that works with session cookies
 * Better-auth handles session management automatically via httpOnly cookies
 * We don't need to manually inject tokens - the cookies are sent automatically
 */
export class BetterAuthTokenProvider implements AuthTokenProvider {
  /**
   * Better-auth uses session cookies, not manual token injection
   * The cookies are automatically included in requests by the browser
   * We return null to let the browser handle session cookies naturally
   */
  getToken(): Promise<string | null> {
    // Better-auth uses httpOnly session cookies that are automatically
    // included in requests by the browser. We don't need to manually
    // inject any tokens - the session is handled via cookies.
    return Promise.resolve(null);
  }
}

// Export a singleton instance
export const betterAuthTokenProvider = new BetterAuthTokenProvider();
